import { render, staticRenderFns } from "./createConsultant.vue?vue&type=template&id=8f61a46a&scoped=true&"
import script from "./createConsultant.vue?vue&type=script&lang=js&"
export * from "./createConsultant.vue?vue&type=script&lang=js&"
import style0 from "./createConsultant.vue?vue&type=style&index=0&id=8f61a46a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f61a46a",
  null
  
)

export default component.exports